import { defineMessages } from 'react-intl';

export const messages = defineMessages({
	searchPlaceholder: {
		id: 'fastshift.customer-selection.domain-selection-table-search.search-placeholder',
		defaultMessage: 'Search',
		description: 'Placeholder for the search input',
	},
	searchLabel: {
		id: 'fastshift.customer-selection.domain-selection-table-search.search-label',
		defaultMessage: 'Search',
		description: 'Label for the search input',
	},
});
